module.exports = __webpack_public_path__ + "static/media/generic-map.027c2484.png";